/**
 * @generated SignedSource<<7c57e3b1e98ae9af3c3a7fa5d1a8e853>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type leadSectionTopHomeV2Content$data = {
  readonly entityId: string;
  readonly urlAlias: string;
  readonly " $fragmentSpreads": FragmentRefs<"contentCoverImageContent" | "entityLink" | "homeSecondaryV2ContentItemContent">;
  readonly " $fragmentType": "leadSectionTopHomeV2Content";
};
export type leadSectionTopHomeV2Content$key = {
  readonly " $data"?: leadSectionTopHomeV2Content$data;
  readonly " $fragmentSpreads": FragmentRefs<"leadSectionTopHomeV2Content">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "leadSectionTopHomeV2Content",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "urlAlias",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityLink"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "homeSecondaryV2ContentItemContent"
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "withLandscape250x99",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "withSize1200x800",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "withSize540x360",
          "value": true
        }
      ],
      "kind": "FragmentSpread",
      "name": "contentCoverImageContent"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "80b2ea5c840d2d8549b0640e7c2ae5e4";

export default node;
